import { render, staticRenderFns } from "./HeaderCollapseNavigation.vue?vue&type=template&id=5ed3afa9&"
import script from "./HeaderCollapseNavigation.vue?vue&type=script&lang=js&"
export * from "./HeaderCollapseNavigation.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCollapseNavigation.vue?vue&type=style&index=0&id=5ed3afa9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports